/**
 * useReferralCookie — liest ?ref=CODE aus der URL, setzt einen 30-Tage-Cookie
 * und meldet den Klick am Backend. Der Cookie bleibt für spätere Checkouts
 * bestehen. Cross-Cutting: wird im App-Root einmal montiert.
 */
import { useEffect, useRef } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const COOKIE_NAME = 'hs_ref';
const COOKIE_DAYS = 30;

const setCookie = (name, value, days) => {
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${d.toUTCString()};path=/;SameSite=Lax`;
};

export const getReferralCode = () => {
  const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : '';
};

export const clearReferralCookie = () => {
  document.cookie = `${COOKIE_NAME}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;`;
};

export function useReferralCookie() {
  // React 18 StrictMode ruft useEffect zweimal auf – wir schützen den Klick.
  const sentRef = useRef(false);
  useEffect(() => {
    if (sentRef.current) return;
    sentRef.current = true;
    try {
      const p = new URLSearchParams(window.location.search);
      const ref = (p.get('ref') || '').trim().toUpperCase();
      if (!ref) return;
      // Cookie setzen (überschreibt vorhandenen – Last-Click-Attribution)
      setCookie(COOKIE_NAME, ref, COOKIE_DAYS);
      // Klick anonym trackens – silent fail, blockiert Nutzer nie
      axios.post(`${API}/api/shop/affiliates/track/click`, {
        code: ref,
        landing_url: window.location.href,
        referer: document.referrer || '',
        session_id: localStorage.getItem('shop_session_id') || '',
      }).catch(() => {});
    } catch { /* noop */ }
  }, []);
}
